// Разборът на малкото markdown, което пише AI помощникът: абзаци, заглавия
// („# …") и списъци („- ", „* ", „1. "). Отделно от компонента, защото
// react-refresh иска файлът на компонента да изнася само компоненти.

export type AnswerBlock =
  | { kind: "heading"; text: string }
  | { kind: "paragraph"; lines: string[] }
  | { kind: "list"; ordered: boolean; items: { text: string; depth: number }[] };

const BULLET = /^(\s*)[-*•]\s+(.*)$/;
const NUMBERED = /^(\s*)\d+[.)]\s+(.*)$/;
const HEADING = /^#{1,6}\s+(.*)$/;

/** Текстът на отговора → блокове. Празен ред затваря абзац/списък. */
export function parseAnswer(text: string): AnswerBlock[] {
  const blocks: AnswerBlock[] = [];
  let paragraph: string[] | null = null;
  let list: Extract<AnswerBlock, { kind: "list" }> | null = null;

  const closeAll = () => {
    if (paragraph) blocks.push({ kind: "paragraph", lines: paragraph });
    if (list) blocks.push(list);
    paragraph = null;
    list = null;
  };

  for (const rawLine of text.replace(/\r\n/g, "\n").split("\n")) {
    const line = rawLine.replace(/\s+$/, "");
    if (!line.trim()) {
      closeAll();
      continue;
    }
    const heading = HEADING.exec(line.trim());
    if (heading) {
      closeAll();
      blocks.push({ kind: "heading", text: heading[1] });
      continue;
    }
    const bullet = BULLET.exec(line);
    const numbered = bullet ? null : NUMBERED.exec(line);
    const itemMatch = bullet ?? numbered;
    if (itemMatch) {
      const ordered = Boolean(numbered);
      if (paragraph) {
        blocks.push({ kind: "paragraph", lines: paragraph });
        paragraph = null;
      }
      const depth = Math.min(3, Math.floor(itemMatch[1].length / 2));
      if (!list || (list.ordered !== ordered && depth === 0)) {
        if (list) blocks.push(list);
        list = { kind: "list", ordered, items: [] };
      }
      list.items.push({ text: itemMatch[2], depth });
      continue;
    }
    if (list && /^\s/.test(line)) {
      // Продължение на пункта на следващ ред — САМО с отстъп. Ред без отстъп
      // (напр. „Непотвърдено: …“ веднага след списъка) е нов абзац.
      const last = list.items[list.items.length - 1];
      last.text = `${last.text} ${line.trim()}`;
      continue;
    }
    if (list) {
      blocks.push(list);
      list = null;
    }
    paragraph = paragraph ?? [];
    paragraph.push(line.trim());
  }
  closeAll();
  return blocks;
}
